(function () {
  'use strict';
  console.log("🚀 RAMVÄLJAREN STARTAD - OVERLAY v13 (A5 + FRAKTINFO + DOMÄN-KOLL)");

  var style = document.createElement('style');
  style.innerHTML = `
    .qw-price-locked {
      opacity: 0 !important; 
      pointer-events: none !important;
    }
    .qw-frame-overlay {
      position: absolute !important;
      top: 0 !important;
      left: 0 !important;
      width: 100% !important;
      height: 100% !important;
      object-fit: contain !important;
      pointer-events: none !important; 
      z-index: 50 !important;
      background: transparent !important;
      transition: opacity 0.2s ease-in-out !important;
      will-change: opacity !important;
      transform: translateZ(0) !important; 
      backface-visibility: hidden !important;
    }
    /* --- NYTT: Design för frakt-varningen --- */
    .qw-shipping-notice {
      display: none;
      margin-top: 15px;
      padding: 12px 15px;
      background-color: #f7f7f7;
      border-left: 3px solid #000;
      font-size: 0.9em;
      line-height: 1.4;
      color: #333;
      animation: qwFadeIn 0.3s ease-in-out;
    }
    .qw-shipping-notice.is-visible {
      display: block;
    }
    @keyframes qwFadeIn {
      from { opacity: 0; transform: translateY(-5px); }
      to { opacity: 1; transform: translateY(0); }
    }
  `;
  document.head.appendChild(style);

  // ---------------------------------------------------------
  // 1. LÄNKAR FÖR STÅENDE (VERTIKALA) RAMAR
  // ---------------------------------------------------------
  var OVERLAY_IMAGES_VERTICAL = {
    'black': 'https://cdn.shopify.com/s/files/1/0837/2869/5638/files/blacktransparentnew.webp?v=1786097475',
    'white': 'https://cdn.shopify.com/s/files/1/0837/2869/5638/files/white-transparent.webp?v=1786039927',
    'oak': 'https://cdn.shopify.com/s/files/1/0837/2869/5638/files/lightwoodnew.webp?v=1786096620',
    'dark-wood': 'https://cdn.shopify.com/s/files/1/0837/2869/5638/files/darkwoodnew1.webp?v=1786096794',
    'none': 'https://cdn.shopify.com/s/files/1/0837/2869/5638/files/noframevertihori.webp?v=1786046468'
  };

  // ---------------------------------------------------------
  // 2. LÄNKAR FÖR LIGGANDE (HORISONTELLA) RAMAR
  // ---------------------------------------------------------
  var OVERLAY_IMAGES_HORIZONTAL = {
    'black': 'https://cdn.shopify.com/s/files/1/0837/2869/5638/files/blackhoriNEWNEW.webp?v=1786100315', 
    'white': 'https://cdn.shopify.com/s/files/1/0837/2869/5638/files/whitehoriNEWNEW.webp?v=1786098812', 
    'oak': 'https://cdn.shopify.com/s/files/1/0837/2869/5638/files/lightwood-NEWNEW.webp?v=1786098391', 
    'dark-wood': 'https://cdn.shopify.com/s/files/1/0837/2869/5638/files/darkwoodhoriNEWNEW.webp?v=1786099351',
    'none': 'https://cdn.shopify.com/s/files/1/0837/2869/5638/files/noframehorre.webp?v=1786046321'
  };

  var FRAME_LABELS = {
    sv: { oak: 'Träram', 'dark-wood': 'Mörk träram', black: 'Svart träram', white: 'Vit träram', none: 'Ingen ram' },
    en: { oak: 'Wood frame', 'dark-wood': 'Dark wood frame', black: 'Black frame', white: 'White frame', none: 'No frame' }
  };

  // --- NYTT: Frakt-texterna ---
  var SHIPPING_NOTICE_TEXT = {
    sv: '📦 <b>Observera:</b> Inramade posters monteras för hand. Leveranstiden förlängs med 3-4 arbetsdagar.',
    en: '📦 <b>Please note:</b> Framed posters are assembled by hand. Delivery time is extended by 3-4 business days.'
  };

  function preloadOverlays() {
    var urls = [];
    for (var kv in OVERLAY_IMAGES_VERTICAL) { if (OVERLAY_IMAGES_VERTICAL[kv]) urls.push(OVERLAY_IMAGES_VERTICAL[kv]); }
    for (var kh in OVERLAY_IMAGES_HORIZONTAL) { if (OVERLAY_IMAGES_HORIZONTAL[kh]) urls.push(OVERLAY_IMAGES_HORIZONTAL[kh]); }
    for (var i = 0; i < urls.length; i++) {
        var img = new Image();
        img.src = urls[i];
    }
  }

  function formatMoney(cents, locale) {
    var activeCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'SEK';
    var lang = locale === 'sv' ? 'sv-SE' : 'en-US';
    if (activeCurrency === 'USD') lang = 'en-US'; 
    if (activeCurrency === 'GBP') lang = 'en-GB';
    if (activeCurrency === 'EUR') lang = 'de-DE';

    var options = { style: 'currency', currency: activeCurrency };
    if (activeCurrency === 'SEK') {
      options.minimumFractionDigits = 0;
      options.maximumFractionDigits = 0;
    } else {
      options.minimumFractionDigits = 2;
      options.maximumFractionDigits = 2;
    }
    return (cents / 100).toLocaleString(lang, options);
  }

  function normalizeSizeKey(str) {
    var s = (str || '').toLowerCase();
    if (s.indexOf('a5') !== -1) return 'a5'; // <-- NYTT: A5 TILLAGD HÄR
    if (s.indexOf('a4') !== -1) return 'a4';
    if (s.indexOf('a3') !== -1) return 'a3';
    if (s.indexOf('a2') !== -1) return 'a2';
    if (s.indexOf('a1') !== -1) return 'a1';
    if (s.indexOf('27') !== -1 && s.indexOf('35') !== -1) return '27x35';
    if (s.indexOf('30') !== -1 && s.indexOf('40') !== -1) return '30x40';
    if (s.indexOf('40') !== -1 && s.indexOf('50') !== -1) return '40x50';
    if (s.indexOf('45') !== -1 && s.indexOf('60') !== -1) return '45x60';
    if (s.indexOf('50') !== -1 && s.indexOf('70') !== -1) return '50x70';
    if (s.indexOf('60') !== -1 && s.indexOf('90') !== -1) return '60x90';
    if (s.indexOf('70') !== -1 && s.indexOf('100') !== -1) return '70x100';
    return null;
  }

  function getSizeFromVariant(variant) {
    var options = [variant.option1, variant.option2, variant.option3];
    for (var i = 0; i < options.length; i++) {
      if (options[i] && normalizeSizeKey(options[i])) return options[i];
    }
    return null;
  }

  var isHorizontal = false;
  var hasCheckedTags = false;

  function determineFormat(callback) {
      if (hasCheckedTags) {
          callback();
          return;
      }
      var cleanPath = window.location.pathname.replace(/\/$/, '');
      fetch(cleanPath + '.js')
          .then(function(res) { return res.json(); })
          .then(function(data) {
              if (data && data.tags) {
                  for (var i = 0; i < data.tags.length; i++) {
                      if (data.tags[i].toLowerCase() === 'liggande' || data.tags[i].toLowerCase() === 'horizontal') {
                          isHorizontal = true;
                          break;
                      }
                  }
              }
              hasCheckedTags = true;
              callback();
          })
          .catch(function() {
              hasCheckedTags = true; 
              callback();
          });
  }

  function updateOverlay(frameKey) {
    var allImgs = document.querySelectorAll('.product-gallery img, .product-media img, .product-single__media img, .product__media-item img, .gallery img');
    var visibleMainImgs = [];
    
    for (var i = 0; i < allImgs.length; i++) {
        var img = allImgs[i];
        if (!img.closest('.product-media--thumbnails, .thumbnail-list, .thumbnail, [data-thumbnail]')) {
            if (img.offsetWidth > 10 || img.clientWidth > 10) {
                visibleMainImgs.push(img);
            }
        }
    }

    if (visibleMainImgs.length === 0) return;

    var targetImg = visibleMainImgs[0];
    var activeImages = isHorizontal ? OVERLAY_IMAGES_HORIZONTAL : OVERLAY_IMAGES_VERTICAL;
    var container = targetImg.parentElement;
    
    if (container.tagName.toLowerCase() === 'picture') {
        container = container.parentElement;
    }

    if (window.getComputedStyle(container).position === 'static') {
        container.style.position = 'relative';
    }

    var oldOverlays = document.querySelectorAll('.qw-frame-overlay');
    for (var o = 0; o < oldOverlays.length; o++) {
        if (oldOverlays[o].parentElement !== container) {
            oldOverlays[o].parentNode.removeChild(oldOverlays[o]);
        }
    }

    var overlay = container.querySelector('.qw-frame-overlay');

    if (!activeImages[frameKey] || activeImages[frameKey] === '') {
        if(overlay) overlay.style.opacity = '0'; 
        return;
    }

    if (!overlay) {
        overlay = document.createElement('img');
        overlay.className = 'qw-frame-overlay';
        overlay.style.opacity = '0'; 
        overlay.src = activeImages[frameKey];
        container.appendChild(overlay);
        
        requestAnimationFrame(function() {
            requestAnimationFrame(function() {
                overlay.style.opacity = '1';
            });
        });
    } else {
        overlay.src = activeImages[frameKey];
        overlay.style.opacity = '1';
    }
  }

  function init() {
    var container = document.querySelector('.qw-frame-selector');
    var productForm = document.querySelector('form[action*="/cart/add"]') || document.querySelector('.product-form form');

    if (!container || !productForm) return false;

    var frameVariants = [];
    try {
      frameVariants = JSON.parse(container.dataset.frameVariants || '[]');
    } catch (err) {
      return true; 
    }

    var locale = container.dataset.locale || 'en';
    var labels = FRAME_LABELS[locale] || FRAME_LABELS.en;

    // --- NYTT: Skapa frakt-rutan och kolla om vi är på .se eller .com ---
    var isSwedishSite = window.location.hostname.indexOf('.se') !== -1;
    var domainLocale = isSwedishSite ? 'sv' : 'en';

    var shippingNotice = document.createElement('div');
    shippingNotice.className = 'qw-shipping-notice';
    shippingNotice.innerHTML = SHIPPING_NOTICE_TEXT[domainLocale];
    container.appendChild(shippingNotice);

    var items = container.querySelectorAll('.qw-frame-item');
    var labelSpan = document.getElementById('qw-selected-frame-name');
    var dynPrices = container.querySelectorAll('.qw-frame-item__price--dynamic');

    var selectedFrame = 'none';
    var selectedFrameImg = '';
    var currentFramePrice = 0;
    var currentFrameVariantId = null;
    var basePriceCents = 0;
    
    var variantCache = {};
    var isUpdatingPrice = false;
    var unlockTimeout = null;
    var localizedFramePrices = {};
    var frameAlreadyAdded = false;
    
    frameVariants.forEach(function(v) {
      fetch('/variants/' + v.variant_id + '.js')
        .then(function(res) { return res.json(); })
        .then(function(data) { localizedFramePrices[v.key] = data.price; })
        .catch(function(e) { });
    });

    function lockPrices() {
      var containers = document.querySelectorAll('.price, .product-info__price, .product-price');
      containers.forEach(function(c) { c.classList.add('qw-price-locked'); });
      clearTimeout(unlockTimeout);
      unlockTimeout = setTimeout(unlockPrices, 1000);
    }

    function unlockPrices() {
      var containers = document.querySelectorAll('.price, .product-info__price, .product-price');
      containers.forEach(function(c) { c.classList.remove('qw-price-locked'); });
    }

    var observerTimeout = null;
    var priceObserver = new MutationObserver(function(mutations) {
      if (selectedFrame === 'none' || isUpdatingPrice) return;
      
      clearTimeout(observerTimeout);
      observerTimeout = setTimeout(function() {
          var themeTriedToUpdate = false;
          for(var m=0; m < mutations.length; m++) {
            var el = mutations[m].target.nodeType === 1 ? mutations[m].target : mutations[m].target.parentElement;
            if (el && el.closest && el.closest('.price, .product-info__price, .product-price')) {
              themeTriedToUpdate = true;
              break;
            }
          }
          if (themeTriedToUpdate) lockPrices();
      }, 10);
    });

    priceObserver.observe(document.body, { childList: true, subtree: true, characterData: true });

    for (var i = 0; i < items.length; i++) {
      items[i].addEventListener('click', function () {
        for (var j = 0; j < items.length; j++) {
          items[j].classList.remove('is-selected');
          items[j].setAttribute('aria-selected', 'false');
        }

        this.classList.add('is-selected');
        this.setAttribute('aria-selected', 'true');

        var previousFrame = selectedFrame;
        selectedFrame = this.dataset.frame || 'none';
        
        var frameName = this.dataset.name || labels[selectedFrame] || selectedFrame;
        if (labelSpan) labelSpan.textContent = frameName;

        // --- NYTT: Visa eller dölj frakt-varningen när kunden klickar ---
        if (selectedFrame !== 'none') {
            shippingNotice.classList.add('is-visible');
        } else {
            shippingNotice.classList.remove('is-visible');
        }

        determineFormat(function() {
            updateOverlay(selectedFrame);
        });

        selectedFrameImg = this.dataset.img || '';
        if (!selectedFrameImg) {
          var imgEl = this.querySelector('img');
          if (imgEl) selectedFrameImg = imgEl.src;
        }

        if (selectedFrame !== 'none') {
            var sizeValue = null;
            if (variantCache[lastVariantId]) {
                sizeValue = getSizeFromVariant(variantCache[lastVariantId]);
            }
            var key = normalizeSizeKey(sizeValue);
            var match = frameVariants.find(function(v) { return v.key === key; });
            
            if (match) {
                currentFrameVariantId = match.variant_id;
                currentFramePrice = localizedFramePrices[key] || match.price;
            }
        } else {
            currentFrameVariantId = null;
            currentFramePrice = 0;
        }

        if (selectedFrame === 'none' && previousFrame === 'none') {
        } else {
           updatePricesUI();
        }
      });
    }

    function updatePricesUI() {
      isUpdatingPrice = true;
      for (var k = 0; k < dynPrices.length; k++) {
        dynPrices[k].textContent = currentFramePrice > 0 ? '+' + formatMoney(currentFramePrice, locale) : '–';
      }
      if (basePriceCents > 0) {
        var total = basePriceCents + (selectedFrame !== 'none' ? currentFramePrice : 0);
        var formattedTotal = formatMoney(total, locale);
        var selectors = ['.product-info__price .theme-money', '.product-info__price .money', '.product-price .theme-money', '.product-price .money', '.price__current', '.price-item--regular', '.price .theme-money', '.price-item'].join(', ');
        var priceElements = document.querySelectorAll(selectors);
        for (var p = 0; p < priceElements.length; p++) {
          if (priceElements[p].textContent !== formattedTotal) {
             priceElements[p].textContent = formattedTotal;
          }
        }
      }
      unlockPrices();
      setTimeout(function() { isUpdatingPrice = false; }, 20);
    }

    function applyVariantData(posterVariant) {
      var sizeValue = getSizeFromVariant(posterVariant);
      var key = normalizeSizeKey(sizeValue);
      var match = null;
      for (var i = 0; i < frameVariants.length; i++) {
        if (frameVariants[i].key === key) {
          match = frameVariants[i];
          break;
        }
      }
      if (posterVariant && posterVariant.price) {
        basePriceCents = posterVariant.price;
      }
      if (match) {
        currentFrameVariantId = match.variant_id;
        currentFramePrice = localizedFramePrices[key] || match.price;
      } else {
        currentFramePrice = 0;
        currentFrameVariantId = null;
      }
      if (selectedFrame !== 'none') {
         updatePricesUI();
      }
    }

    var lastVariantId = null;
    function checkVariantLoop() {
      var variantInput = productForm.querySelector('[name="id"]');
      if (variantInput && variantInput.value && variantInput.value !== lastVariantId) {
        lastVariantId = variantInput.value;
        if (selectedFrame !== 'none') lockPrices();
        if (variantCache[lastVariantId]) {
          applyVariantData(variantCache[lastVariantId]);
        } else {
          fetch('/variants/' + lastVariantId + '.js')
            .then(function (res) { return res.json(); })
            .then(function (variant) { 
              variantCache[lastVariantId] = variant;
              applyVariantData(variant); 
            })
            .catch(function (err) { 
              if (selectedFrame !== 'none') updatePricesUI(); 
            });
        }
      }
    }

    productForm.addEventListener('change', checkVariantLoop);
    checkVariantLoop();
    
    setInterval(checkVariantLoop, 150);

    productForm.addEventListener('submit', function (e) {
      if (selectedFrame === 'none' || !currentFrameVariantId) {
        var propSV = productForm.querySelector('input[name="properties[_Vald Ram]"]');
        var propEN = productForm.querySelector('input[name="properties[_Selected Frame]"]');
        if (propSV && propSV.parentNode) propSV.parentNode.removeChild(propSV);
        if (propEN && propEN.parentNode) propEN.parentNode.removeChild(propEN);
        return;
      }

      if (frameAlreadyAdded) {
        frameAlreadyAdded = false; 
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();

      var btn = productForm.querySelector('button[name="add"], button[type="submit"]');
      var originalBtnHtml = btn ? btn.innerHTML : '';
      if (btn) {
        btn.innerHTML = locale === 'sv' ? 'Lägger i varukorg...' : 'Adding to cart...';
        btn.disabled = true;
      }

      var frameLabel = labels[selectedFrame] || selectedFrame;
      var frameVariantId = parseInt(currentFrameVariantId, 10);
      var posterQuantityInput = productForm.querySelector('[name="quantity"]');
      var posterQuantity = posterQuantityInput ? parseInt(posterQuantityInput.value, 10) || 1 : 1;

      var propName = 'properties[' + (locale === 'sv' ? '_Vald Ram' : '_Selected Frame') + ']';
      var hiddenProp = productForm.querySelector('input[name="' + propName + '"]');
      if (!hiddenProp) {
        hiddenProp = document.createElement('input');
        hiddenProp.type = 'hidden';
        hiddenProp.name = propName;
        productForm.appendChild(hiddenProp);
      }
      hiddenProp.value = frameLabel;

      var frameOnlyPayload = {
        items: [{
          id: frameVariantId,
          quantity: posterQuantity,
          properties: {
            '_poster': document.title,
            'Color': frameLabel,
            '_image': selectedFrameImg
          }
        }]
      };

      if (locale === 'sv') {
        frameOnlyPayload.items[0].properties = {
          '_poster': document.title,
          'Färg': frameLabel,
          '_image': selectedFrameImg
        };
      }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(frameOnlyPayload)
      })
      .then(function (response) {
        if (!response.ok) throw new Error('API Error');
        return response.json();
      })
      .then(function () {
        if (btn) {
          btn.innerHTML = originalBtnHtml;
          btn.disabled = false;
        }
        frameAlreadyAdded = true;
        if (typeof productForm.requestSubmit === 'function') {
          productForm.requestSubmit();
        } else {
          productForm.submit();
        }
      })
      .catch(function (error) {
        console.error('QW Frame Error:', error);
        if (btn) {
          btn.innerHTML = originalBtnHtml;
          btn.disabled = false;
        }
        alert('Det uppstod ett fel. Försök ladda om sidan.');
      });

    }, true);
    
    determineFormat(function(){}); 
    
    return true;
  }

  if (!init()) {
    var checkInterval = setInterval(function() {
      if (init()) {
        preloadOverlays();
        clearInterval(checkInterval);
      }
    }, 100);
  } else {
    preloadOverlays();
  }
})();